import { Check, PanelLeft } from 'lucide-react';
import { useDemoMode } from './DemoModeContext';

// =========================================================================
// DemoModeMenuItem — "Executive rail" toggle in the AccountMenu. Fork-owned.
//
// A compact sibling of BrandMenuItem: same row geometry, but a two-state
// toggle rather than a submenu, because the choice only has two values and a
// portalled panel for two radio rows is machinery without a reader.
//
// It is here as well as in Settings → Appearance for one reason: if someone
// in the room asks to see the rest of the build, the presenter should reach
// it from where they already are rather than navigating away from the page
// they are being asked about. The menu stays open on click, so the rail
// changes behind it while the row's own state flips.
//
// AccountMenu mounts this with a two-line seam; everything else lives here.
// =========================================================================

export function DemoModeMenuItem() {
  const { mode, setMode } = useDemoMode();
  const executive = mode === 'executive';

  return (
    <button
      type="button"
      role="menuitemcheckbox"
      aria-checked={executive}
      title={
        executive
          ? 'Executive rail — three sections. Switch to the full build.'
          : 'Full build — every section. Switch back to the executive rail.'
      }
      className="flex w-full cursor-default items-center gap-2 rounded-md px-2 py-1.5 text-sm text-zinc-700 outline-none hover:bg-zinc-100 dark:text-zinc-200 dark:hover:bg-zinc-800"
      onClick={() => setMode(executive ? 'full' : 'executive')}
    >
      <PanelLeft className="h-4 w-4 text-zinc-500" strokeWidth={1.6} />
      Executive rail
      <span className="ml-auto text-xs text-muted">{executive ? 'On' : 'Off'}</span>
      {executive ? (
        <Check className="h-3.5 w-3.5 text-zinc-500" />
      ) : (
        <span className="h-3.5 w-3.5" aria-hidden="true" />
      )}
    </button>
  );
}
